
import { formatDate } from "~/utils";
export default {
  props: ["newsList"],
  methods: {
    transformDate(date) {
      return formatDate(date);
    },
  },
};
